import { s as g, h as y, E as v, c as h, w as d, T as c, u as f, i as E } from "./emotion-react-jsx-runtime.browser.esm-CsRinUqv.js";
import * as u from "react";
var m = function(e, n) {
  var s = arguments;
  if (n == null || !y.call(n, "css"))
    return u.createElement.apply(void 0, s);
  var i = s.length, r = new Array(i);
  r[0] = v, r[1] = h(e, n);
  for (var t = 2; t < i; t++)
    r[t] = s[t];
  return u.createElement.apply(null, r);
};
(function(a) {
  var e;
  e || (e = a.JSX || (a.JSX = {}));
})(m || (m = {}));
var p = /* @__PURE__ */ d(function(a, e) {
  var n = a.styles, s = g([n], void 0, u.useContext(c)), i = u.useRef();
  return f(function() {
    var r = e.key + "-global", t = new e.sheet.constructor({
      key: r,
      nonce: e.sheet.nonce,
      container: e.sheet.container,
      speedy: e.sheet.isSpeedy
    }), l = !1, o = document.querySelector('style[data-emotion="' + r + " " + s.name + '"]');
    return e.sheet.tags.length && (t.before = e.sheet.tags[0]), o !== null && (l = !0, o.setAttribute("data-emotion", r), t.hydrate([o])), i.current = [t, l], function() {
      t.flush();
    };
  }, [e]), f(function() {
    var r = i.current, t = r[0], l = r[1];
    if (l) {
      r[1] = !1;
      return;
    }
    if (s.next !== void 0 && E(e, s.next, !0), t.tags.length) {
      var o = t.tags[t.tags.length - 1].nextElementSibling;
      t.before = o, t.flush();
    }
    e.insert("", s, t, !1);
  }, [e, s.name]), null;
});
function S() {
  for (var a = arguments.length, e = new Array(a), n = 0; n < a; n++)
    e[n] = arguments[n];
  return g(e);
}
function x() {
  var a = S.apply(void 0, arguments), e = "animation-" + a.name;
  return {
    name: e,
    styles: "@keyframes " + e + "{" + a.styles + "}",
    anim: 1,
    toString: function() {
      return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
    }
  };
}
export {
  p as G,
  S as c,
  x as k
};
